import React, { useContext } from "react";
import { Redirect, Switch, BrowserRouter as Router } from "react-router-dom";
import Route from "./Route";

import Dashboard from "../pages/Dashboard";
import Exercises from "../pages/Exercises";
import DefineExercise from "../pages/_details/DefineExercise";
import DefineWorkout from "../pages/_details/DefineWorkout";
import DefineMealplan from "../pages/_details/DefineMealplan";
import DefineForm from "../pages/_details/DefineForm";
import Workouts from "../pages/Workouts";
import Mealplans from "../pages/Mealplans";
import Forms from "../pages/Forms";
import Clients from "../pages/Clients";
import Login from "../pages/Login";
import PasswordReset from "../pages/Login/PasswordReset";
import Programs from "../pages/Programs";
import DefineProgram from "../pages/_details/DefineProgram";
import Subs from "../pages/Subs";
import UserContext from "../services/context/userContext";
import Closed from "../pages/Closed";
import Logout from "../pages/Logout";
import SetLogingPopup from "../components/_clients/LargePopup/SetLogingPopup";
import ToolBox from "../pages/Toolbox";
import DashboardHome from "../pages/Dashboard/DashboardHome";
import ExerciseHistory from "../components/_clients/ExerciseHistory";
import UpgradeSubs from "../pages/Subs/UpgradeSubs";
import ClientOverview from "../pages/Clients/ClientOverview";
// import ClientOverview from "../pages/ClientOverview";


export default function Routes({ signed }) {

  const user = useContext(UserContext);
  const isAdmin = user.admin;
  console.log("signed ",signed,user)
  return (
    <Router>
      {!signed ? (
      
        <>
          <Switch>
            <Route path="/" exact component={Login} signed={signed} />
            <Route path="/login" exact component={Login} signed={signed} />
            <Route path="/reset-password" exact component={PasswordReset} signed={signed} />
            <Redirect to="/login" />
          </Switch>
        </>
      ) : (
        user.status !== 'Closed' ? (
        <>
        
          <Switch>
            <Route path="/" exact component={DashboardHome} active="dashboard" isPrivate signed={signed} />
            
            
            {/* <Route  path="/dashboardold"  component={Dashboard} active="dashboard" isPrivate signed={signed} /> */}
            <Route  path="/dashboard"  component={DashboardHome} active="dashboard" isPrivate signed={signed} />
            <Route  path="/toolbox"  component={ToolBox} active="toolbox" isPrivate signed={signed} />
            {/* <Route path="/loging" component={SetLogingPopup} /> */}
            <Route path="/exercises" component={Exercises} active="exercises" isPrivate signed={signed} />
            <Route path="/exercise/:id" component={DefineExercise} active="exercises" isPrivate signed={signed} />
            <Route path="/exercise" component={DefineExercise} active="exercises" isPrivate signed={signed} />
            <Route path="/exercise/coptotrainee/:id" component={DefineExercise} active="exercises" isPrivate signed={signed} />
            <Route path="/workouts" component={Workouts} active="workouts" isPrivate signed={signed} />
            <Route path="/workout" component={DefineWorkout} active="workouts" isPrivate signed={signed} />
            <Route path="/mealplans" component={Mealplans} active="mealplans" isPrivate signed={signed} />
            <Route path="/mealplan" component={DefineMealplan} active="mealplans" isPrivate signed={signed} />
            {/* <Route path="/clientsOverview" component={ClientOverview} active="clientsOverview" isPrivate signed={signed} /> */}
            <Route path="/clients/:id" component={Clients} active="clients" isPrivate signed={signed} />
            <Route path="/exerciseHistory" component={ExerciseHistory} active="clients" isPrivate signed={signed} />
            <Route path="/exerciseHistory/:id" component={ExerciseHistory} active="clients" isPrivate signed={signed} />
            <Route path="/logging" component={SetLogingPopup} active="clients" isPrivate signed={signed} />
            <Route path="/logging/:id" component={SetLogingPopup} active="clients" isPrivate signed={signed} />
            <Route path="/clients" component={ClientOverview} active="clients" isPrivate signed={signed} />
            <Route path="/forms" component={Forms} active="forms" isPrivate signed={signed} />
            <Route path="/forms/:id" component={Forms} active="forms" isPrivate signed={signed} />
            <Route path="/form" component={DefineForm} active="forms" isPrivate signed={signed} />
            <Route path="/programs" component={Programs} active="programs" isPrivate signed={signed} />
            <Route path="/program" component={DefineProgram} active="programs" isPrivate signed={signed} />
            <Route path="/logout" component={Logout} active="dashboard" isPrivate signed={signed} />
            {isAdmin ? <Route path="/subsOldOne" component={Subs} active="subs" isPrivate signed={signed} /> : <></>}
            {isAdmin ? <Route path="/subs" component={UpgradeSubs} active="subs" isPrivate signed={signed} /> : <></>}
            <Redirect to="/dashboard" />
          </Switch>
        </>
        ):(
          <Switch>
            <Route path="/closed" component={Closed} active="closed" isPrivate signed={signed} />
            <Route path="/logout" component={Logout} active="dashboard" isPrivate signed={signed} />
            <Redirect to="/closed" />
          </Switch>
        )
      )}
    </Router>
  );
}
